module.exports = __webpack_public_path__ + "static/media/on-eye_classic-Chic.a2f9728f.jpg";